"use client"

import PropTypes from "prop-types"
import { RiPrinterCloudLine } from "react-icons/ri"

import theme from "@/theme"

import { Button } from "./Button"

/**
 * This component renders a button with icon and optional text for opening files for printing
 *
 * @param {object} props
 * @param {string} props.number - The document number to open and print
 * @param {string} props.text - The text to display on the button
 * @param {node} props.children - Optional icon to display inside the button
 * @returns {JSX.Element}
 */
export const PrintButton = ({ number, text, children, ...props }) => {
  const handleOpenPdf = (number) => {
    const link = document.createElement("a")
    link.href = `/api/order-offer-file/${number}`
    link.target = "_blank"
    link.rel = "noopener noreferrer"
    document.body.appendChild(link)
    link.click()
    link.remove()
  }

  return (
    <Button onClick={() => handleOpenPdf(number)} {...props}>
      {children ?? <RiPrinterCloudLine size={theme.iconSizes.xtraLarge} />}
      <span>{text}</span>
    </Button>
  )
}

PrintButton.propTypes = {
  /** Defines the document number to open and print */
  number: PropTypes.string.isRequired,
  /** Defines the text of the button */
  text: PropTypes.string,
  /** Defines the icon of the button */
  children: PropTypes.node,
}
